export default __webpack_public_path__ + "static/5-39b29b9800706d2a48ad9ed080188256.webp";